"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADVISOR_V2_GROUP_NAME = exports.AdvisorV2AssignmentStatus = exports.AdvisorV2AssignmentType = void 0;
var AdvisorV2AssignmentType;
(function (AdvisorV2AssignmentType) {
    AdvisorV2AssignmentType["newUser"] = "NEW_USER";
    AdvisorV2AssignmentType["existingUserManuallySet"] = "EXISTING_USER_MANUALLY_SET";
})(AdvisorV2AssignmentType || (exports.AdvisorV2AssignmentType = AdvisorV2AssignmentType = {}));
var AdvisorV2AssignmentStatus;
(function (AdvisorV2AssignmentStatus) {
    AdvisorV2AssignmentStatus["active"] = "ACTIVE";
    AdvisorV2AssignmentStatus["inactive"] = "INACTIVE";
})(AdvisorV2AssignmentStatus || (exports.AdvisorV2AssignmentStatus = AdvisorV2AssignmentStatus = {}));
exports.ADVISOR_V2_GROUP_NAME = 'showAdvisorV2';
